import { render, staticRenderFns } from "./VideoPresentationModal.vue?vue&type=template&id=3787b935"
import script from "./VideoPresentationModal.vue?vue&type=script&lang=js"
export * from "./VideoPresentationModal.vue?vue&type=script&lang=js"
import style0 from "./VideoPresentationModal.vue?vue&type=style&index=0&id=3787b935&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports